<template>
  <div
    class="text-image"
    :class="{ 'is-reverted': showTextOnLeftSide }"
  >
    <div class="grid grid-cols-12 gap-8 lg:gap-12 xl:gap-24">
      <div class="col-span-12 lg:col-span-5 col-first">
        <div class="text-image-image-container">
          <img
            v-if="imageUrl"
            :src="imageUrl"
            :alt="imageAlt"
          >
        </div>
      </div>
      <div class="col-span-12 lg:col-span-7 col-second">
        <div class="text-image-rich-text-container richtext">
          <slot />
          <KfButtonContainer
            :button-container-links="links"
            :button-container-position-horizontal="btnAlignmentHorizontal"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KfButtonContainer from '@/components/button-container/ButtonContainer.vue';

export default {
  name: 'KfTextImageTwoColumn',
  components: {
    KfButtonContainer,
  },
  props: {
    imageUrl: {
      type: String,
      default: () => '',
    },
    imageAlt: {
      type: String,
      default: '',
    },
    links: {
      type: Array,
      default: null,
    },
    showTextOnLeftSide: {
      type: Boolean,
      default: () => false,
    },
    btnAlignmentHorizontal: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="postcss">
.text-image {
  &-image-container {
    @apply flex items-center h-full;

    img {
      @apply w-full rounded;
    }
  }

  &-rich-text-container {
    @apply flex flex-col justify-center items-start h-full;

    .richtext {
      @apply mb-6;

      &:only-child {
        @apply mb-0;
      }
    }
  }

  &-link {
    @apply mb-8;

    &:last-of-type {
      @apply mb-0;
    }
  }

  &.is-reverted {
    @screen lg {
      .col-first {
        order: 2;
      }

      .col-second {
        order: 1;
      }
    }
  }
}
</style>
